import store from "../store";

/**
 * check if the provided value present in a reserved keywords list
 * @param {String} value value to compare in list
 * @returns {Bollean}
 */
const checkReservedKeywords = (value, type = "snowflake") => {
  const keywords =
    type === "mysql"
      ? store.getState()?.config?.mysqlRestrictedColumnNames
      : store.getState()?.config?.restrictedColumnNames;

  return keywords.some((word) => word.toLowerCase() === value.toLowerCase());
};

export { checkReservedKeywords };
